import {sendUnclaimedStudentInvitations} from 'educator/app/actions';
import {connect} from 'react-redux';
import BulkAction from 'educator/app/components/dashboard/bulk-action';

const mapStateToProps = ({educator}) => ({
  educator,
});

export default connect(mapStateToProps, {sendUnclaimedStudentInvitations})(BulkAction);
